import React, {Component} from "react";
import {InputNumber} from "antd";
import {injectIntl} from "react-intl";
import FieldError from "./FieldError";

class SAInputPercentage extends Component {

  render() {
    const {error, className, name, onChange, placeholder, value, ...attributes} = this.props;
    const errorClassName = error ? " error":'';

    return (
      <span className={errorClassName + " " + className}>
        <InputNumber
          name={name}
          placeholder={placeholder}
          value={value}
          min={0}
          max={100}
          step={5}
          formatter={value => `${value}%`}
          parser={value => value.replace('%', '')}
          onChange={onChange}
          {...attributes}
        />
        <br/>
        {error && (
          <FieldError error={error}/>
        )}
      </span>
    );
  }
}

export default injectIntl(SAInputPercentage);
